export const isMobileType = {
  Android: function () {
    return navigator.userAgent.match(/Android/i)
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry|BB10/i)
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i)
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i)
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i)
  },
  isSafari: function () {
    return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  },
  any: function () {
    return (
      isMobileType.Android() ||
      isMobileType.BlackBerry() ||
      isMobileType.iOS() ||
      isMobileType.Opera() ||
      isMobileType.Windows()
    )
  },
  getOsName: function () {
    var osName = 'Unknown OS'
    if (isMobileType.Android()) {
      osName = 'Android'
    }

    if (isMobileType.BlackBerry()) {
      osName = 'BlackBerry'
    }

    if (isMobileType.iOS()) {
      osName = 'iOS'
    }

    if (isMobileType.Opera()) {
      osName = 'Opera Mini'
    }

    if (isMobileType.Windows()) {
      osName = 'Windows'
    }
    return {
      osName,
      type: 'mobile',
    }
  },
}
